export interface ColorProp {
    name: string;
    value: string;
}

export const DEFAULT_TENANT_COLOR = '#000000c2'; // default color

export const COLOR_PALETTE: ColorProp[] = [
    { name: 'Ocean Blue', value: '#5FBAC9' },
    { name: 'Royal Purple', value: '#453DA2' },
    { name: 'Coral Pink', value: '#D95864' },
    { name: 'Amber Orange', value: '#F1A94C' },
    { name: 'Sky Blue', value: '#50A5E7' },
    { name: 'Sunshine Yellow', value: '#F3E767' },
    { name: 'Forest Green', value: '#52A846' },
    { name: 'Slate Gray', value: '#586674' },
    { name: 'Crimson Red', value: '#93003A' }
];